module.exports = __webpack_public_path__ + "static/media/twitter-logo.8cea1391.svg";